import type { components } from './types.gen';

type UserRole = components['schemas']['UserRole'];

// 인증 세션은 localStorage에 보관. role은 me 로딩 중 초기 표시용(최종 판단은 /auth/me).
const TOKEN_KEY = 'odaeri:token';
const ROLE_KEY = 'odaeri:role';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredRole(): UserRole | null {
  return localStorage.getItem(ROLE_KEY) as UserRole | null;
}

export function setSession(token: string, role: UserRole): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ROLE_KEY, role);
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
}

// 401 감지 → AuthContext가 핸들러를 등록해 React Router로 이동(client는 직접 이동 안 함).
let unauthorizedHandler: (() => void) | null = null;

export function setUnauthorizedHandler(fn: (() => void) | null): void {
  unauthorizedHandler = fn;
}

export function emitUnauthorized(): void {
  unauthorizedHandler?.();
}
